export function addMissingAlt(): void {
  const images: NodeListOf<HTMLImageElement> = document.querySelectorAll('img')
  images.forEach((image: HTMLImageElement) => {
    const hasNoAlt: boolean = !image.hasAttribute('alt')
    if (hasNoAlt) {
      image.setAttribute('alt', '')
    }
  })
}
